export default "__VITE_ASSET__DV6VDD$E__"